(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    var container = document.getElementById('main-collection-product-grid');
    var grid = container && container.querySelector('[data-collection-grid]');
    if (!grid) return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');

    var url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', container.dataset.id);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var freshContainer = html.getElementById('main-collection-product-grid');
        var freshItems = freshContainer ? freshContainer.querySelectorAll('[data-collection-grid] > *') : [];
        var firstNewLink = null;

        freshItems.forEach(function (item) {
          var imported = document.importNode(item, true);
          if (!firstNewLink) firstNewLink = imported.querySelector('.product_card_title a') || imported.querySelector('a[href]');
          grid.appendChild(imported);
        });

        var wrapper = button.closest('[data-load-more-wrapper]');
        var freshWrapper = freshContainer && freshContainer.querySelector('[data-load-more-wrapper]');
        if (wrapper && freshWrapper) {
          wrapper.replaceWith(document.importNode(freshWrapper, true));
        } else if (wrapper) {
          wrapper.remove();
        }

        if (firstNewLink) firstNewLink.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = button.href;
      });
  });
})();
